// extracted by mini-css-extract-plugin
export default {"table":"ViewGolds_table__eiaW2","search":"ViewGolds_search__Jshy0","icons":"ViewGolds_icons__3E6KX"};